import { autoBeforeEachTest } from '@atlassian/jira-platform-auto-before-each-test/src/auto-before-each-test.tsx';

let ssrFailedMarker = false;
let failedMarkers = new Set<string>();

autoBeforeEachTest(() => {
	ssrFailedMarker = false;
	failedMarkers = new Set();
});

/**
 * @internal only for local usage by rendering guard
 */
export const markSSRFailure = (fallbackId: string | undefined) => {
	ssrFailedMarker = true;
	if (fallbackId != null) {
		failedMarkers.add(fallbackId);
	}
};

/**
 * reports if SSR failure was reported via ReportSSRFailOnUse
 */
export const hasFailedSSR = () => ssrFailedMarker;
export const getFailedMarkers = () => failedMarkers;
